import { defineComponent as _defineComponent } from 'vue'


interface Props {
	/**
	 * 「トークルームへのリプライがない時」文言
	 */
	noReplyText: string;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
    noReplyText: { type: String, required: true }
  },
  setup(__props: any, { expose }) {
  expose()

const props = __props as {
	/**
	 * 「トークルームへのリプライがない時」文言
	 */
	noReplyText: string;
}
/**
 * リプライ0件時の表示。
 */



const __returned__ = { props }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})